<p *ngIf="item?.header?.value" class="information-panel-item__header">
  {{ item.header.value }}
</p>
<div class="information-panel-item__line"></div>
<div
  *ngIf="item?.description?.value"
  class="information-panel-item__description"
  [innerHTML]="item.description?.value | safe"
></div>
